const common = {
  saltwhite: "rgb(255, 255, 255)",
  saltblack: "rgb(0, 0, 0)",
};
/* TODO: a few of these are probably out of date and need checking */
export const saltlight = {
  ...common,
  /* Color palette will stay the same no matter of theming */
  saltred10: "rgb(255, 227, 224)",
  saltred20: "rgb(255, 207, 201)",
  saltred30: "rgb(255, 187, 178)" /* ffbbb2 */,
  saltred40: "rgb(255, 167, 156)" /* #ffa79c */,
  saltred50: "rgb(255, 148, 133)" /* ff9485 */,
  saltred100: "rgb(255, 128, 111)",
  saltred200: "rgb(255, 108, 88)",
  saltred300: "rgb(255, 89, 66)" /* 555942 */,
  saltred400: "rgb(237, 65, 42)",
  saltred500: "rgb(227, 43, 22)",
  saltred600: "rgb(196, 32, 16)" /* #c42010 */,
  saltred700: "rgb(166, 21, 11)",
  saltred800: "rgb(136, 10, 5)",
  saltred900: "rgb(106, 0, 0)",
  saltorange10: "rgb(255, 232, 191)",
  saltorange20: "rgb(254, 223, 166)",
  saltorange30: "rgb(254, 214, 142)",
  saltorange40: "rgb(254, 205, 118)",
  saltorange50: "rgb(254, 197, 94)",
  saltorange100: "rgb(250, 181, 81)" /* faB551 */,
  saltorange200: "rgb(246, 165, 68)" /* f6a544 */,
  saltorange300: "rgb(242, 149, 56)" /* #f29538 */,
  saltorange400: "rgb(238, 133, 43)",
  saltorange500: "rgb(234, 115, 25)" /* #ea7319 */,
  saltorange600: "rgb(224, 101, 25)" /* e06519*/,
  saltorange700: "rgb(214, 85, 19)",
  saltorange800: "rgb(204, 68, 13)",
  saltorange900: "rgb(194, 52, 7)" /* #c23407 */,
  saltgreen10: "rgb(209, 244, 201)",
  saltgreen20: "rgb(184, 232, 182)",
  saltgreen30: "rgb(160, 221, 164)",
  saltgreen40: "rgb(136, 210, 145)",
  saltgreen50: "rgb(112, 199, 127)",
  saltgreen100: "rgb(93, 189, 116)",
  saltgreen200: "rgb(77, 180, 105)",
  saltgreen300: "rgb(60, 171, 96)",
  saltgreen400: "rgb(48, 156, 90)",
  saltgreen500: "rgb(36, 135, 75)",
  saltgreen600: "rgb(24, 114, 61)",
  saltgreen700: "rgb(12, 93, 46)",
  saltgreen800: "rgb(1, 73, 32)",
  saltgreen900: "rgb(0, 57, 18)",
  saltteal10: "rgb(218, 240, 240)",
  saltteal20: "rgb(199, 232, 232)",
  saltteal30: "rgb(180, 224, 225)",
  saltteal40: "rgb(162, 217, 218)",
  saltteal50: "rgb(141, 205, 209)",
  saltteal100: "rgb(123, 193, 200)",
  saltteal200: "rgb(99, 181, 192)",
  saltteal300: "rgb(73, 160, 172)",
  saltteal400: "rgb(48, 149, 166)",
  saltteal500: "rgb(0, 130, 151)",
  saltteal600: "rgb(27, 107, 133)",
  saltteal700: "rgb(0, 85, 113)",
  saltteal800: "rgb(1, 65, 86)",
  saltteal900: "rgb(0, 49, 76)",
  saltblue10: "rgb(203, 231, 249)",
  saltblue20: "rgb(183, 222, 246)",
  saltblue30: "rgb(164, 213, 244)",
  saltblue40: "rgb(144, 204, 242)",
  saltblue50: "rgb(125, 195, 240)" /* #7dc3f0 */,
  saltblue100: "rgb(100, 177, 228)" /* #64B1E4 */,
  saltblue200: "rgb(75, 159, 216)",
  saltblue300: "rgb(51, 141, 205)" /* 338dcd */,
  saltblue400: "rgb(45, 129, 189)",
  saltblue500: "rgb(38, 112, 169)" /* 2670a9 */,
  saltblue600: "rgb(21, 92, 147)" /* 155c93 */,
  saltblue700: "rgb(0, 71, 123)",
  saltblue800: "rgb(12, 53, 102)",
  saltblue900: "rgb(0, 40, 88)",
  saltblue1000: "rgb(0, 18, 40)",
  saltpurple10: "rgb(249, 224, 247)",
  saltpurple20: "rgb(247, 212, 244)",
  saltpurple30: "rgb(245, 201, 241)",
  saltpurple40: "rgb(243, 189, 238)",
  saltpurple50: "rgb(241, 178, 235)",
  saltpurple100: "rgb(223, 156, 225)",
  saltpurple200: "rgb(205, 135, 215)",
  saltpurple300: "rgb(192, 116, 203)",
  saltpurple400: "rgb(169, 97, 181)",
  saltpurple500: "rgb(150, 78, 162)",
  saltpurple600: "rgb(129, 60, 141)",
  saltpurple700: "rgb(103, 46, 122)",
  saltpurple800: "rgb(83, 37, 109)",
  saltpurple900: "rgb(59, 16, 84)",
  saltgray10: "rgb(242, 244, 246)",
  saltgray20: "rgb(234, 237, 239)" /* #EAEDEF */,
  saltgray30: "rgb(224, 228, 233)",
  saltgray40: "rgb(217, 221, 227)" /* #D9DDE3 */,
  saltgray50: "rgb(206, 210, 217)",
  saltgray60: "rgb(197, 201, 208)" /* #C5C9D0 */,
  saltgray70: "rgb(180, 183, 190)" /* B4B7BE*/,
  saltgray80: "rgb(159, 163, 170)",
  saltgray90: "rgb(132, 135, 142)" /* #84878e */,
  saltgray100: "rgb(116, 119, 127)",
  saltgray200: "rgb(97, 101, 110)",
  saltgray300: "rgb(76, 80, 91)" /* 4c505b*/,
  saltgray400: "rgb(68, 72, 79)",
  saltgray500: "rgb(59, 63, 70)",
  saltgray600: "rgb(47, 49, 54)",
  saltgray700: "rgb(42, 44, 47)",
  saltgray800: "rgb(36, 37, 38)",
  saltgray900: "rgb(22, 22, 22)" /* #161616 */,
};

export const saltColorMap: Record<string, string> = saltlight;
